import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { RestorableProgrammation } from '@teetsh/app/src/types/programmations';

export const PROGRAMMATIONS_TRASH_KEY = 'programmations_trash';

function fetchProgrammations() {
  const requestURL = '/programmations/trash';
  return request(requestURL, {
    method: 'GET',
  }).then(({ data }: { data: RestorableProgrammation[] }) => data || []);
}

export function useProgrammationsTrash() {
  return useQuery({
    queryKey: [PROGRAMMATIONS_TRASH_KEY],
    queryFn: () => fetchProgrammations(),
    placeholderData: [],
    refetchOnWindowFocus: false,
  });
}
